export const TERMS_AND_CONDITIONS_ENDPOINTS = {
    borrowerTermsAndConditions: '/documents/group/',
    acceptTermsAndConditions: '/documents/accept',
};
